import axios from 'axios';
import handleError from 'services/handleError';
import { setUpdateStatusState } from '../redux/user-data/userDataSlice';

const createTaskFromGallery = async (toolPath, taskData, thunkAPI) => {
  const { getState, dispatch } = thunkAPI;
  const state = getState();
  const currentCreditNumber = state.userdata.credits;

  try {
    const { data } = await axios.post(
      `${toolPath}/task/create-from-gallery`,
      taskData
    );

    if (data) {
      dispatch(
        setUpdateStatusState({
          creditsToCompare: currentCreditNumber,
          status: true,
        })
      );
    }

    return data;
  } catch (error) {
    if (!error.response) {
      return thunkAPI.rejectWithValue({
        message:
          'Network error. Please check your internet connection or try again later.',
        errorType: error.code || 'network_error',
        details: error.message,
      });
    }
    const status = error.response?.status;
    const data = error.response?.data;
    const errorDetails = await handleError(status, data);

    return thunkAPI.rejectWithValue(errorDetails);
  }
};

export default createTaskFromGallery;
